import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { UseFormReturn } from "react-hook-form";
import type { AdminFormValues } from "@/types/admin";

interface LeadershipConfidenceProps {
  form: UseFormReturn<AdminFormValues>;
}

const ratingOptions = [
  "Stämmer inte alls",
  "Stämmer dåligt",
  "Varken eller",
  "Stämmer delvis",
  "Stämmer helt"
];

export const LeadershipConfidence = ({ form }: LeadershipConfidenceProps) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium">Självförtroende kring ledarskapsförmågor</h3>
      
      <FormField
        control={form.control}
        name="leadership_confidence.equal_knowledge"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Jag kan leda en grupp även om den har lika mycket kunskap och erfarenhet som jag</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="flex flex-col space-y-2"
              >
                {ratingOptions.map((option) => (
                  <div key={option} className="flex items-center space-x-2">
                    <RadioGroupItem value={option} id={`equal_knowledge_${option}`} />
                    <label htmlFor={`equal_knowledge_${option}`}>{option}</label>
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="leadership_confidence.more_knowledge"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Jag kan leda en grupp om jag har mer kunskap och erfarenhet än gruppmedlemmarna</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="flex flex-col space-y-2"
              >
                {ratingOptions.map((option) => (
                  <div key={option} className="flex items-center space-x-2">
                    <RadioGroupItem value={option} id={`more_knowledge_${option}`} />
                    <label htmlFor={`more_knowledge_${option}`}>{option}</label>
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="leadership_confidence.different_opinion"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Jag kan leda en grupp även om gruppmedlemmarna tenderar att värdera en annan persons åsikt högre</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="flex flex-col space-y-2"
              >
                {ratingOptions.map((option) => (
                  <div key={option} className="flex items-center space-x-2">
                    <RadioGroupItem value={option} id={`different_opinion_${option}`} />
                    <label htmlFor={`different_opinion_${option}`}>{option}</label>
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="leadership_confidence.disagreement"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Jag kan leda en grupp när gruppmedlemmarna inte kommer överens med varandra</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="flex flex-col space-y-2"
              >
                {ratingOptions.map((option) => (
                  <div key={option} className="flex items-center space-x-2">
                    <RadioGroupItem value={option} id={`disagreement_${option}`} />
                    <label htmlFor={`disagreement_${option}`}>{option}</label>
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="leadership_confidence.disinterested"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Jag kan leda en grupp när gruppmedlemmarna inte är intresserade av uppgiften</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="flex flex-col space-y-2"
              >
                {ratingOptions.map((option) => (
                  <div key={option} className="flex items-center space-x-2">
                    <RadioGroupItem value={option} id={`disinterested_${option}`} />
                    <label htmlFor={`disinterested_${option}`}>{option}</label>
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="leadership_confidence.enthusiastic"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Jag kan leda en grupp när gruppen är entusiastisk över uppgiften</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="flex flex-col space-y-2"
              >
                {ratingOptions.map((option) => (
                  <div key={option} className="flex items-center space-x-2">
                    <RadioGroupItem value={option} id={`enthusiastic_${option}`} />
                    <label htmlFor={`enthusiastic_${option}`}>{option}</label>
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};